import { render, staticRenderFns } from "./ImportCredential.vue?vue&type=template&id=efddc6bc&scoped=true"
import script from "./ImportCredential.vue?vue&type=script&lang=js"
export * from "./ImportCredential.vue?vue&type=script&lang=js"
import style0 from "./ImportCredential.vue?vue&type=style&index=0&id=efddc6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efddc6bc",
  null
  
)

export default component.exports